/**
 * Types et constantes pour les templates d'emails personnalisés
 */

export interface EmailTemplate {
  id: string;
  user_id: string;
  name: string;
  body: string;
  color: string;
  created_at: string;
  updated_at: string;
}

/**
 * Variable disponible pour interpolation dans les templates
 */
export interface TemplateVariable {
  key: string;
  label: string;
  example: string;
  description: string;
}

/**
 * Liste des variables disponibles pour interpolation
 * Ces variables correspondent aux champs de la table cases
 */
export const TEMPLATE_VARIABLES: TemplateVariable[] = [
  {
    key: 'clientFirstName',
    label: 'Prénom client',
    example: 'Marie',
    description: 'Le prénom du client (cases.client_first_name)',
  },
  {
    key: 'clientLastName',
    label: 'Nom client',
    example: 'Dupont',
    description: 'Le nom de famille du client (cases.client_last_name)',
  },
  {
    key: 'clientEmail',
    label: 'Email client',
    example: 'marie@example.com',
    description: 'L\'adresse email du client (cases.client_email)',
  },
  {
    key: 'clientPhone',
    label: 'Téléphone client',
    example: '06 12 34 56 78',
    description: 'Le numéro de téléphone du client (cases.client_phone)',
  },
  {
    key: 'companyName',
    label: 'Entreprise',
    example: 'Acme Corp',
    description: 'Le nom de l\'entreprise (cases.company_name)',
  },
  {
    key: 'centerName',
    label: 'Centre',
    example: 'Bercy',
    description: 'Le nom du centre Smile World (cases.center)',
  },
  {
    key: 'eventDate',
    label: 'Date événement',
    example: '15/03/2025 à 19h00',
    description: 'La date et heure de l\'événement formatée (cases.event_date)',
  },
  {
    key: 'participants',
    label: 'Participants',
    example: '25',
    description: 'Le nombre de participants (cases.participants)',
  },
  {
    key: 'activities',
    label: 'Activités',
    example: 'Karting, Bowling',
    description: 'Liste des activités souhaitées (cases.activities)',
  },
  {
    key: 'occasion',
    label: 'Occasion',
    example: 'Team Building',
    description: 'L\'occasion de l\'événement (cases.occasion)',
  },
  {
    key: 'budget',
    label: 'Budget',
    example: '2500€',
    description: 'Le budget du projet (cases.budget)',
  },
  {
    key: 'address',
    label: 'Adresse',
    example: '123 rue de la Paix',
    description: 'L\'adresse complète (cases.address)',
  },
  {
    key: 'city',
    label: 'Ville',
    example: 'Paris',
    description: 'La ville (cases.city)',
  },
  {
    key: 'postalCode',
    label: 'Code postal',
    example: '75001',
    description: 'Le code postal (cases.postal_code)',
  },
];

/**
 * Couleurs prédéfinies pour les templates
 */
export const TEMPLATE_COLORS = [
  { value: '#3B82F6', label: 'Bleu' },
  { value: '#10B981', label: 'Vert' },
  { value: '#F59E0B', label: 'Orange' },
  { value: '#EF4444', label: 'Rouge' },
  { value: '#8B5CF6', label: 'Violet' },
  { value: '#EC4899', label: 'Rose' },
  { value: '#06B6D4', label: 'Cyan' },
  { value: '#84CC16', label: 'Lime' },
  { value: '#F97316', label: 'Orange foncé' },
  { value: '#14B8A6', label: 'Turquoise' },
];

